import { FC } from 'react';
import Image from '@base/lib/ThemeImage';
import { IICartGroupBar } from 'mod/cart/interface';
import { HtmlRender } from '@base/snippets/HtmlRender';
import styles from './cartMenu.module.less';

type IGroupFooterProps = {
    data: IICartGroupBar;
    iconSize: number;
};

export const GroupFooter: FC<IGroupFooterProps> = props => {
    const { data, iconSize } = props;
    const { icon, tips } = data;
    return !icon && !tips ? null : (
        <div className={styles['group-footer']}>
            {!!icon && (
                <Image
                    className={styles.icon}
                    src={icon}
                    width={iconSize}
                    background={false}
                    fixed
                />
            )}

            {!!tips && <HtmlRender className={styles.tips} html={tips}/>}
        </div>
    )
};
